import * as React from 'react'
import { useState } from 'react';
import logo from './images/logo.png';
import Quote from './Components/Quote.js'
import Loading from './Components/Loading.js'
import './css/App.css';
const proxy = "https://evening-shelf-78886.herokuapp.com/";
const API = "https://thesimpsonsquoteapi.glitch.me/quotes";
const episodeAPI = "https://frinkiac.com/api/search?q=";
const episodeInfoAPI = "https://frinkiac.com/api/caption?e="
const gifURL = "https://frinkiac.com/mp4/"

export default function App() {

  const [isFetching, setIsFetching] = useState(false)
  const [isQuoteShowing, setIsQuoteShowing] = useState(false)
  const [quoteInfo, setQuoteInfo] = useState({})
  const [episodeInfo, setEpisodeInfo] = useState({})
  const [fetchingError, setFetchingError] = useState(false)

  async function handleQuoteFlow() {
    /*
      function will handle the three api calls needed for the quote to work. If at any point there's an error
      catch it and display error message + error image. 
    */
    try {
      setFetchingError(false)
      setIsFetching(true)
      const quoteObj = await getQuote()
      const { quote } = quoteObj
      const episodeInfoObj = await getEpisodeInfo(quote)
      const title = await getEpisodeTitle(episodeInfoObj)
      setQuoteInfo(quoteObj)
      setEpisodeInfo({
        episode: episodeInfoObj.Episode,
        timestamp: episodeInfoObj.Timestamp,
        title
      })
      setIsQuoteShowing(true)
      setIsFetching(false)
    } catch (error) {
      console.log(error)
      setFetchingError(true)
      setIsFetching(false)
      alert("D'oh! There was an error getting your quote. Please try again.")
    }
  }

  async function getQuote() {
    const api_call = await fetch(proxy + API);
    const response = await api_call.json();
    //response returns array of objects. Only need the first
    return response[0]
  }

  async function getEpisodeInfo(quote) {
    const api_call = await fetch(proxy + episodeAPI + quote);
    const response = await api_call.json();
    //response returns array of objects. Only need the first
    return response[0]
  }

  async function getEpisodeTitle(episodeObj) {
    const api_call = await fetch(proxy + episodeInfoAPI + episodeObj.Episode + "&t=" + episodeObj.Timestamp);
    const response = await api_call.json();
    return response.Episode.Title
  }

  function viewGif() {
    const gifEnd = episodeInfo.timestamp + 5000;
    window.open(gifURL + episodeInfo.episode + "/" + episodeInfo.timestamp + "/" + gifEnd + ".mp4")
    return;
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="Simpsons logo" className="logo" />
      </header>
      <main>
        <h1>Quote Generator</h1>
        {isQuoteShowing ? (
          <div>
            <Quote
              quoteInfo={quoteInfo}
              episodeInfo={episodeInfo}
            />
            <div className="button-container">
              <button onClick={() => viewGif()}>View Gif</button>
            </div>
          </div>
        ) : (
          <Loading
            isFetching={isFetching}
            fetchingError={fetchingError}
          />
        )}
        <div className="button-container">
          <button onClick={() => handleQuoteFlow()}>Get Quote</button>
        </div>
      </main>
    </div>
  );
}